import { Injectable } from '@angular/core';
import { currentSelectedBsk, getArrayField, getInternalAction, getLastFirstName, getProperty, loadVariableName, prepareInfosDoc } from '@core/_utils/tools.utils';
import { EditorService } from './editor.service';
import { FormatRequestTools } from './formatrequest.tools';
import { TokenService } from '@core/_services/token.service';
import { ApiV6Service } from './apiv6.service';
import { forkJoin, lastValueFrom, map } from 'rxjs';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class DocumentService {

    public currentSelectedBsk: currentSelectedBsk;
    private currentDocId;
    public comment = '';
    public currentDocName = '';
    public nbError = 0;
    public reqBsk = '';
    public bskStatus: any;
    private VariableName = {};
    private docVariable: any;
    private bskMode: boolean = false;
    
    constructor(
        public editorService: EditorService,
        private formatRequestTools: FormatRequestTools,
        private tokenService: TokenService,
        protected _messageService: MessagesService,
        private translate: TranslateService,
        private api: ApiV6Service
    ) {
        // this.loadVariableName();     
        this.VariableName = loadVariableName(this.translate);
    }

    public clear() {
        this.docVariable = null;
        this.bskMode = false;
    }

    public setDocId(aCurrentDocId) {
        this.currentDocId = aCurrentDocId;
    }

    public getDocId() {
        return this.currentDocId;
    }

    public setBskMode(aBskMode) {
        this.bskMode = aBskMode;
    }

    public getBskMode() {
        return this.bskMode;
    }

    public setValues(aDocVariable) {
        this.clear();
        this.docVariable = aDocVariable;
    }

    public getPropertyValue(aName) {
        return getProperty(this.docVariable, aName) ?? '';
    }

    public async execValid(action, aInfoMail, listVariable, aUserInfos) {
        this.nbError = 0;
        let wRequest = '';
        let wRes: any;

        if (this.currentSelectedBsk.bskModeAutoLock === true) {
            this.formatRequestTools.clear(this.currentDocId);
            wRequest = this.formatRequestTools.checkin();
            wRes = await this.execBasicAction('checkin', wRequest);
        } else {
            // Verif lock
            wRes = await this.execVerifyCheckOut(this.tokenService.login)
            if (wRes === false) {
                this.nbError++;
                return;
            }
        }

        if (this.comment !== '') {
            wRes = await this.saveComment(aUserInfos);
        }

        wRes = await this.saveIndex(listVariable);

        this.formatRequestTools.clear(this.currentDocId);
        this.formatRequestTools.action = action;
        this.formatRequestTools.currentDocName = this.currentDocName;     

        if (action === 'validmail') {            
            wRequest = this.formatRequestTools.actionUpdate(aInfoMail);
            wRes = await this.execBasket('mailinsert', wRequest, this.currentDocId);        

            wRequest = this.formatRequestTools.actionUpdate(aInfoMail);
            wRes = await this.execBasket('validmail', wRequest, this.currentDocId);        
        } else {
            wRequest = this.formatRequestTools.actionUpdate(aInfoMail);
            wRes = await this.execBasket(action, wRequest, this.currentDocId);        
        }
    }

    public async execVerifyCheckOut(aLogin) {
        let wRes: any;
        const wParams = { DocIDFilter: this.currentDocId };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('verifycheckout', wParams));
            if (wRes.Status === 'ERROR') {
                throw new Error();
            }
            return this.verifyCheckUser(wRes, aLogin);
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('State_Doc_KO'));
            return false;
        }
    }

    private verifyCheckUser(aData, aLogin) {
        let wRes = false;
        let wUser = '';
        if (aData) {
            if (aData.CkOutList.CkOut) {
                if (aData.CkOutList.CkOut.CkOutDocID === this.currentDocId) {
                    wUser = getArrayField(aData.CkOutList.CkOut.CkOutUser);
                    if (wUser === '' || wUser === aLogin) {
                        wRes = true;
                    } else {
                        this._messageService.addErrorNoStick(this.translate.instant('Lock_Usr_1', {user: wUser}));
                    }
                }
            }
        }
        return wRes;
    }

    public async saveIndex(aListVariable) {
        let wRequest = '';
        this.formatRequestTools.clear(this.currentDocId);
        wRequest = this.formatRequestTools.setIndex(this.editorService, aListVariable, true);
        return await this.execBasicAction('index', wRequest);
    }

    public async saveComment(aUserInfos) {
        let wRequest = '';
        this.formatRequestTools.clear(this.currentDocId);
        wRequest = this.formatRequestTools.setComment(this.comment, getLastFirstName(aUserInfos));
        this.comment = '';
        return await this.execBasicAction('comment', wRequest);
    }

    public async saveMail(aInfoMail) {
        let wRes: any;
        this.formatRequestTools.clear(this.currentDocId);
        this.formatRequestTools.action = 'savemail';
        this.formatRequestTools.currentDocName = this.currentDocName;
        let wRequest = this.formatRequestTools.actionUpdate(aInfoMail);
        wRes = await this.execBasket('savemail', wRequest, this.currentDocId);
        return wRes;
    }

    public async execBasket(aAction, aRequest, aDocId) {
        let wRes: any;
        let wAction: string;
        this.bskStatus = null;
        wRes = false;
        wAction = getInternalAction(aAction);
        wRes = await this.execBasicAction(wAction, aRequest);
        this.bskStatus = wRes;
        this.reqBsk = aRequest;
        return wRes;
    }

    public async rename(aNewDocName) {
        this.formatRequestTools.clear(this.currentDocId);
        let wRequest = this.formatRequestTools.setChangeDoc('', '', aNewDocName);
        return await this.execBasicAction('changedoc', wRequest);
    }

    public async lockUnlock(aAction, aUserInfos) {
        let wAction = '';
        let wRequest = '';
        this.formatRequestTools.clear(this.currentDocId);
        if (aAction === 'unLock') {
            wAction = 'checkin';
            wRequest = this.formatRequestTools.checkin();
        } else {
            wAction = 'checkout';
            wRequest = this.formatRequestTools.checkout(getLastFirstName(aUserInfos));
        }
        return await this.execBasicAction(wAction, wRequest);
    }

    private async execBasicAction(aAction, aRequest) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction(aAction, aRequest));
            if (wRes.Status === 'ERROR') {
                if (wRes.Message) {
                    throw new Error(wRes.Message);
                } else {
                    throw new Error(wRes.Status);
                }
            }
        } catch (error) {
            this.nbError++;
            console.log('execBasicAction ', aAction);
            return false;
        }
        return true;
    }

    public readInfosDoc(aUpdate, aVariableStorage){
        return forkJoin([
            this.getInformationDoc(aUpdate, this.currentDocId),
            this.api.getIndexDoc(this.currentDocId, aVariableStorage),
            this.api.execUrlAction('baskets', this.currentDocId),
            this.api.getAtfDoc(this.currentDocId),
            this.api.getCustomEditorlist(),            
        ]).pipe(
            map(([getInfoDoc, getIndexDoc, getBasketsDoc, getAtfDoc, getEditorList]) => {
                return {
                    getInfoDoc,
                    getIndexDoc,
                    getBasketsDoc,
                    getAtfDoc,
                    getEditorList,                
                };
            })
        );
    }

    public readInfosDocIndex(aUpdate, aVariableStorage){
        return forkJoin([
            this.getInformationDoc(aUpdate, this.currentDocId),
            this.api.getIndexDoc(this.currentDocId, aVariableStorage),
        ]).pipe(
            map(([getInfoDoc, getIndexDoc]) => {
                return {
                    getInfoDoc,
                    getIndexDoc,
                };
            })
        );
    }

    public readInfosDocVer(aCurrentDocId, aVariableStorage) {
        return forkJoin([
            this.getInformationDoc(false, aCurrentDocId),
            this.api.getCommDoc(aCurrentDocId),
            this.api.getIndexDoc(aCurrentDocId, aVariableStorage),
            this.api.getTraceDoc(aCurrentDocId),
        ]).pipe(
            map(([getInfoDoc, getCommentsDoc, getIndexDoc, getTracesDoc]) => {
                return {
                    getInfoDoc,
                    getCommentsDoc,
                    getIndexDoc,
                    getTracesDoc,
                };
            })
        );
    }

    public readCommTrace() {
        return forkJoin([
            this.api.getCommDoc(this.currentDocId), 
            this.api.getTraceDoc(this.currentDocId),
            ]).pipe(
            map(([getCommentsDoc, getTracesDoc]) => {
                return { getCommentsDoc, getTracesDoc };
            })
        );
    }

    private async getInformationDoc(aUpdate, aCurrentDocId) {
        let wRes: any;
        let wAction = 'infos';
        if (aUpdate === true) {
            wAction = 'infosupdate';
        }
        wRes = await lastValueFrom(this.api.execUrlAction(wAction, aCurrentDocId));
        return {
            Status: wRes.Status,
            Document: prepareInfosDoc(wRes.Document, this.VariableName),
        };
    }
}
